import { Alert } from "antd";

export default function RepetitiveMonthDayAlert() {
  return <Alert
    message="When monthly repetition is selected, if the chosen day doesn't exist in a given month, the billing will be processed on the last day of that month."
    style={{ marginBottom: 24 }}
  />
}
